import { render, staticRenderFns } from "./scroll-down.vue?vue&type=template&id=545ca50d&scoped=true&"
var script = {}
import style0 from "./scroll-down.vue?vue&type=style&index=0&id=545ca50d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ca50d",
  null
  
)

export default component.exports